/*
export default function floatingCta() {
  const scroll = window.scrollY;
  const floatingBtn = document.querySelector('.p-cta');
  const contactSection = document.getElementById('last-contact');

  if (!contactSection) return;

  if (scroll >= 200 && window.pageYOffset <= contactSection.offsetTop) {
    floatingBtn.classList.remove('DownMove');
    floatingBtn.classList.add('UpMove');
  } else {
    if (floatingBtn.classList.contains('UpMove')) {
      floatingBtn.classList.remove('UpMove');
      floatingBtn.classList.add('DownMove');
    }
  }

}
*/